import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { Button, Col, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import { timeForToday } from '../../util/utils';
import { TaskComment } from '../../modules/tasks';
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface AttachedFileListComponentProps {
  attachedFiles: any[];
  downloadFile: (attachFileId: string, fileName: string) => void;
  openImagePreview: (imageData: any) => void;
}

function AttachedFileListComponent({
  attachedFiles,
  downloadFile,
  openImagePreview,
}: AttachedFileListComponentProps) {
  const columns: ColumnsType<TaskComment> = [
    {
      title: '파일명',
      dataIndex: 'name',
      width: '75%',
    },
    {
      title: '생성일시',
      dataIndex: 'createdAt',
      width: '10%',
      render: (text: any, record: any, index: any) =>
        timeForToday(moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss')),
    },
    {
      title: '',
      key: 'action',
      align: 'center',
      width: '15%',
      render: (text, record: any, index) => (
        <Space>
          <Button
            size="small"
            icon={<DownloadOutlined rev={undefined} />}
            onClick={() => downloadFile(record.id, record.name)}
          >
            {/* 다운로드 */}
          </Button>
          <Button
            size="small"
            icon={<EyeOutlined rev={undefined} />}
            disabled={
              record.name.split('.').pop() !== 'jpg' &&
              record.name.split('.').pop() !== 'jpeg' &&
              record.name.split('.').pop() !== 'png' &&
              record.name.split('.').pop() !== 'pdf'
            }
            onClick={() => {
              openImagePreview(record);
            }}
          >
            {/* 미리보기 */}
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <StyledDiv>
      <Row>
        <Col>
          <Title level={5}>첨부파일</Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table<any>
            rowKey="id"
            columns={columns}
            dataSource={attachedFiles}
            pagination={false}
          />
        </Col>
      </Row>
    </StyledDiv>
  );
}
export default AttachedFileListComponent;
